import { useTranslation, useWebAppContext } from 'app/src/shared/hooks'
import { useEffect, type ReactElement } from 'react'

export function DemoExternalOrder(): ReactElement {
  const context = useWebAppContext()

  const { t } = useTranslation('demoApp')

  useEffect(() => {
    context.update({ breadCrumbItems: [] })
    //Evita loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className='mt-8 flex flex-col items-center justify-center gap-8'>
      <h1 className='text-3xl font-bold text-red-600'>{t('SimulateExternalOrderLabel')}</h1>
      <iframe
        width='560'
        height='315'
        src='https://www.youtube.com/embed/WEQE1eyaba0?si=JkU1Ho6T1LRFW7Bb'
        title='YouTube video player'
        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
        allowFullScreen
      ></iframe>
    </div>
  )
}
